// extracted by mini-css-extract-plugin
export var divider = "_xe-0";